import MainLayout from "@/components/layout/applicant/MainLayout.vue";
// import Pagination from "laravel-vue-pagination";
import { mapGetters } from "vuex";
import moment from 'moment';
import axios from "axios";
import { ConvertNumService } from "@/assets/js/convertNumberService.js";
const convertNumberService = new ConvertNumService();
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

export default {
    name: "applicantIndex",

    components: {
        MainLayout,
        // Pagination
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            applicant: {
                name: "",
                email: "",
                address: "",
                phone_number: "",
                gender: ""
            },
            isUpdateApplicant: false,
            resumeList: [],
            applyList: {
                data: []
            },
            jobRequestList: {
                data: []
            },
            result: "",
            apply_count: "",
            mm_num: "",
        };
    },

    computed: {
        ...mapGetters({ applicantId: "applicantId" })
    },

    methods: {
        getApplicantDetail() {
            axios.get("applicant/detail/" + this.applicantId)
                .then(response => {
                    if (!response.data || !response.data.id) {
                        this.$router.push({ name: "notFound" });
                        return;
                    }
                    this.applicant = response.data;
                })
                .catch(error => {
                    console.log("Applicant Detail API Error", error);
                    this.$router.push({ name: "notFound" });
                });
        },

        getResume() {
            axios.get("/applicant/resume/list/" + this.applicantId)
                .then(response => {
                    this.resumeList = response.data || [];
                    this.resume_count = this.convertEng2Mm((this.resumeList.length || 0).toString());
                })
                .catch(error => {
                    if (error.response) {
                        console.log("Resume List API error:::::>", error.response.data);
                    }
                });
        },

        confirmResumeDelete(id) {
            if (window.confirm("ဤ CV ကို ဖျက်လိုပါသလား?")) {
                this.deleteResume(id);
            } else {
                console.log("no");
            }
        },

        deleteResume(id) {
            axios.delete("/applicant/resume/delete/" + id)
            .then(response => {
                    this.resumeList = response.data;
                    this.$notification.success("CV ဖျက်ခြင်း အောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    setTimeout(() => location.reload(), 2000);
                    this.getResume();
                })
                .catch(error => {
                    this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log(error);
                });
        },

        getApplyList(page = 1) {
            axios.get("/apply/list/" + this.applicantId + "?page=" + page)
                .then(response => {
                    this.applyList = response.data;
                    this.apply_count = convertNumberService.convertEng2Mm(this.applyList.total.toString())
                })
                .catch(error => {
                    console.log("Apply List API Error", error);
                });
        },

        getJobRequestList(page=1) {
            axios.get("/applicant/job_request/list/" + this.applicantId + "?page=" + page)
            .then(response => {
                this.jobRequestList = response.data;
                this.jobrequest_count = convertNumberService.convertEng2Mm(this.jobRequestList.total.toString())
            })
            .catch(error => {
                console.log("Apply List API Error", error);
            });
          },

          confirmJobRequestDelete(id) {
            if (window.confirm("ဤအလုပ်တောင်းဆိုချက်ကို ဖျက်လိုပါသလား?")) {
                this.jobRequestdelete(id);
            } else {
                console.log("no");
            }
        },

        jobRequestdelete(id) {
            axios.delete("/applicant/job_request/delete/" + id)
            .then(response => {
                    this.jobRequestList = response.data;
                    this.$notification.success("အလုပ်တောင်းဆိုချက် ဖျက်ခြင်းအောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    setTimeout(() => location.reload(), 2000);
                    this.getJobRequestList();
                })
                .catch(error => {
                    this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log(error);
                });
        },


        downloadResumePdf(id) {
            axios({
                url: axios.defaults.baseURL +"applicant/resume/download/" + id,
                method: "GET",
                responseType: "blob"
            })
            .then((response) => {
                var today = new Date();
                var date = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate();
                var cvName = this.applicant.name + '_' + id + '_' + date + '_CV.pdf';
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', cvName);
                document.body.appendChild(link);
                link.click();
            });
        },

        convertEng2Mm(number) {
            if (number === null || number === undefined) return '၀';
            return convertNumberService.convertEng2Mm(number.toString());
        },

        formatRowNo(index) {
            const num = index + 1;
            return num >= 10 ? num.toString() : '0' + num;
        },

        isExpired(expiredDate) {
            if (!expiredDate) return true;
            return Date.now() >= new Date(expiredDate).getTime();
        }
    },

    mounted() {
        this.getApplicantDetail();
        this.getResume();
        this.getApplyList();
        this.getJobRequestList();
    },

    filters: {
        setMoment: function (value) {
            return moment(value).format("YYYY-MM-DD");
        }
    }
};
